<template>
  <form ref="form" @submit="handleSignIn" novalidate>
    <div class="modal-dialog" style="min-width: 400px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Please Sign In Below</h5>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" v-if="errorMessage">
            {{ errorMessage }}
          </div>
          <div class="form-group row mb-2">
            <div class="col input-container has-validation">
              <input
                type="text"
                class="form-control"
                placeholder="Email Address"
                v-model="username"
                ref="username"
                required
                :disabled="busy"
              />
            </div>
          </div>
          <div class="form-group row mb-2">
            <div class="col input-container has-validation">
              <div class="input-group mb-3">
                <input
                  v-bind:type="[showPassword ? 'text' : 'password']"
                  class="form-control"
                  v-model="password"
                  required
                  placeholder="Password"
                  :disabled="busy"
                  data-lpignore="true"
                />
                <span class="input-group-text" @click="passwordToggle">
                  <alzata-icon
                    :icon="showPassword ? 'far/eye' : 'far/eye-slash'"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-primary text-center"
              :disabled="busy"
            >
              {{ busy ? "Signing In..." : "Sign In" }}
            </button>
          </div>
        </div>
        <div
          class="modal-footer bg-light small"
          style="justify-content: space-between"
        >
          <!-- <router-link
            v-if="$router.hasRoute('alzata:account/create')"
            :to="{ name: 'alzata:account/create' }"
            >Sign Up</router-link
          > -->
          <router-link
            v-if="$router.hasRoute('alzata:account/recover')"
            :to="{ name: 'alzata:account/recover' }"
            >Forgot Password</router-link
          >
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AlzataSignIn",
  data: () => ({
    username: "",
    password: "",
    errorMessage: null,
    showPassword: false,
    busy: false,
    formWasValidated: false,
  }),
  mounted() {
    this.$refs.username.focus();
  },
  methods: {
    ...mapActions("iam", ["setAuthenticationStatus"]),
    async handleSignIn(evt) {
      evt.preventDefault();
      this.errorMessage = null;

      this.busy = true;
      try {
        const result = await this.apiClient.login(this.username, this.password);
        if (result.success) {
          //check if 'admin' or not.
          const res = await this.apiClient.getJson("/api/v1/me", {
            authRequired: true,
          });

          if (res.isAdmin) {
            this.setAuthenticationStatus(result.status);
            window.setTimeout(() => this.$router.replace("/"), 0);
          } else {
            this.errorMessage = "Login failed. You are not an admin.";
            window.setTimeout(() => this.$refs.username.focus(), 0);
          }
        } else {
          this.errorMessage = result.errorMessage;
          window.setTimeout(() => this.$refs.username.focus(), 0);
        }
      } finally {
        this.busy = false;
      }
    },
    passwordToggle() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
